<template>
    <div class="training-submission">
        <el-table
            :data="submissionList"
            style="width: 100%; flex: 1; border: 1px solid #EBEEF5; border-bottom: none; border-radius: 4px;"
            @current-change="handleCurrentChange"
            :header-cell-style="headStyle"
            :cell-style="cellStyle"
        >
            <!-- <el-table-column prop="rank" label="序号" width="80"></el-table-column>
            <el-table-column prop="s_name" label="姓名" width="200"></el-table-column>
            <el-table-column prop="update_time" label="提交时间" align="center"></el-table-column>
            <el-table-column prop="create_time" label="评分" align="center">
                <template slot-scope="scope">
                    <div class="pf-act-content" v-if="role === 3">
                        <template v-if="scope.row.teacher_score">
                            <span>{{ scope.row.teacher_score }}分</span>
                        </template>
                        <template v-else>
                            <el-input-number
                                v-model="teacher_score"
                                controls-position="right"
                                class="pw-input"
                                :min="0"
                                :max="100"
                            ></el-input-number>
                            <el-tooltip content="确定之后，则无法修改分数" placement="top-start">
                                <el-button type="primary" size="small" class="pw-confirm-btn" @click="submitContent(scope.row)">
                                    确定
                                </el-button>
                            </el-tooltip>
                        </template>
                    </div>
                    <div v-if="role === 4">
                        <span v-if="scope.row.teacher_score">{{ scope.row.teacher_score }}</span>
                        <span v-else>暂无评分</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-link type="primary" @click="clickViewDetail(scope.row)" :underline="false" style="color: #006EFF">查看详情</el-link>
                </template>
            </el-table-column> -->
            <el-table-column type="index" label="序号" width="80"> </el-table-column>

            <el-table-column label="姓名">
                <template slot-scope="scope">{{ scope.row.s_name }}</template>
            </el-table-column>

            <el-table-column label="提交时间">
                <template slot-scope="scope">{{ scope.row.time }}</template>
            </el-table-column>

            <el-table-column label="评定状态" v-if="role !== 4">
                <template slot-scope="scope">
                    <span :class="{ fail: scope.row.status === 2 }">{{ scope.row.status === 1 ? "已提交" : scope.row.status === 0?'未提交':"打回重做" }}</span>
                </template>
            </el-table-column>

            <!-- 学生得分列 -->
            <el-table-column label="得分" v-if="role === 4">
                <template slot-scope="scope">
                    {{ scope.row.teacher_status === 0 || scope.row.status !== 1 ? "-" : scope.row.teacher_score }}
                </template>
            </el-table-column>

            <!-- 教师得分打分列 -->
            <el-table-column label="得分" v-if="role !== 4">
                <template slot-scope="scope">
                    <div class="table-scoring" v-if="scope.row.status === 1">
                        <!-- <el-input-number
                            v-model="scope.row.teacher_score"
                            controls-position="right"
                            :precision="2"
                            :min="0"
                            :max="100"
                            size="small"
                        ></el-input-number>
                        <el-button slot="trigger" size="small" type="primary" @click="confirmScore(scope.row)">确定</el-button> -->
                        {{ scope.row.teacher_score }}
                    </div>

                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <div class="table-operate">
                        <el-button type="text" @click="handleAssessmentDetail(scope.row)" v-if="scope.row.status === 1">查看</el-button>
                        <span v-else>-</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="role === 3"
            class="pages-center"
            background
            :current-page.sync="practicalPages.currentPageNum"
            :page-size="practicalPages.eachPageNum"
            :total="practicalPages.total"
            layout="prev, pager, next, jumper"
            @current-change="practicalCurrentChange"
        >
        </el-pagination>
        <!--S 查看详情弹窗-->
        <el-dialog title="查看详情" :visible.sync="viewDetail" width="1100px" class="submit-detail">
            <el-scrollbar class="detail-box">
                <div class="detail-box_answer">
                    <div class="answer-content" v-html="submit_content"></div>

                    <div class="answer-file-list">
                        <div class="file-item" v-for="item in files" :key="item.url">
                            <img :src="getFileIcon(item.name)" alt="" />

                            <div class="file-item_info">
                                <div class="info-top">{{ formatFileName(item.name) }}</div>

                                <div class="info-bottom">
                                    <div class="info-bottom_size">{{ item.size }}</div>
                                    <div class="info-bottom_operate">
                                        <el-button type="text" v-if="getIsPreview(item.name)" @click="previewSource(item)">预览</el-button>
                                        <el-button type="text" @click="downLoadSource(item)">下载</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="comment-content" style="display: flex;">
                    <div class="comment-txt">
                        <p class="detail-text" v-html="submit_content"></p>
                    </div>
                </div> -->

                <div class="teacher-comments">
                    <span class="text">AI评分</span>
                    <span class="comments" v-if="ai_evaluate">{{ ai_evaluate }}</span>
                    <span class="comments" v-else style="color: #999999;">暂无AI评分</span>
                </div>

                <div class="teacher-comments" v-if="role === 3 && analysis && analysis.name">
                    <span class="text">{{ analysis.name }}</span>
                    <span class="comments" style="padding-block: 10px;">
                        <div v-html="analysis.value"></div>
                    </span>
                </div>

                <div class="teacher-comments" v-if="role === 4">
                    <span class="text">教师评语</span>
                    <span class="comments" v-if="teacher_comment">{{ teacher_comment }}</span>
                    <span class="comments" v-else style="color: #999999;">暂无评语</span>
                </div>

                <div class="teacher-comments" v-if="role === 3">
                    <span class="text">教师评语</span>
                    <el-input
                        class="textarea"
                        type="textarea"
                        :rows="6"
                        style="resize:none"
                        placeholder="请输入内容"
                        v-model="teacher_comment"
                    >
                    </el-input>
                </div>
            </el-scrollbar>

            <div class="comment-btns" slot="footer">
                <el-button type="primary" @click="viewDetail = false" v-if="role === 4">确定</el-button>
                <el-button type="primary" @click="submitContent" v-if="role === 3">确定</el-button>
            </div>
        </el-dialog>
        <!--E 查看详情弹窗-->

        <div class="preview-box" v-if="previewUrl">
            <ElImageViewer class="preview-img" :url-list="[previewUrl]" alt="" v-if="['jpg', 'png'].includes(getFileExtensiion)" />

            <i class="el-icon-close" @click="closePreview"></i>
        </div>
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "TrainingSubmissionModule",
    props: {
        analysis: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            role: Number(localStorage.getItem("role")),
            submissionList: [],
            submit_content: "",
            //分页
            practicalPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            viewDetail: false,
            //教师评语
            teacher_comment: "",
            //分数
            teacher_score: 0,
            //学生提交的id
            student_submit_id: "",
            ai_evaluate: "", // ai评分
            files: [], // 文件列表
            previewUrl: "", // 图片预览路径
            currentRow: null,
        };
    },
    created() {
        this.getStudentPractical();
    },
    components: {
        ElImageViewer,
    },
    computed: {
        // 获得文件扩展名
        getFileExtensiion() {
            const fileExtension = this.previewUrl?.slice(((this.previewUrl.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return fileExtension;
        },
    },
    methods: {
        headStyle() {
            return "background: #F2F4F7; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;";
        },
        cellStyle() {
            return "padding-left: 24px; height: 60px; color: #333;";
        },
        //查看学生提交的实训列表
        getStudentPractical() {
            // let params = {
            //     page: c
            //     limit: this.practicalPages.eachPageNum,
            //     sx_id: this.$route.query.sx_id,
            // };
            // this.$shttp.axiosGetBy(
            //     this.$api.drill_showStuPutDrillList,
            //     params,
            //     (res) => {
            //         if (res.code === 200) {
            //             this.submissionList = res.data.data;
            //             this.submit_content = res.data.data.content;
            //             this.practicalPages.total = res.data.total;
            //         }
            //     },
            //     (err) => {
            //         console.log(err);
            //     },
            // );
            const params = {
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter:-1,
                course_node: -1,
                project_id: Number(localStorage.getItem("project_id")),
                page: this.practicalPages.currentPageNum,
                limit:this.practicalPages.eachPageNum,
                type:Number(localStorage.getItem("project_type"))
            };
              if(Number(localStorage.getItem("project_type"))==3){
                    delete params.course_chapter
                    delete params.course_node
                }

            if (this.role !== 4) params.c_id = Number(localStorage.getItem("class_id"));

            this.$shttp.axiosGetBy(this.$api.training_assessment_list, params, (res) => {
                if (res.code === 200) {
                    this.submissionList = res.data.list || [];
                    this.projectPages.total = res.data.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 下载文件
        downLoadSource(file) {
            const link = document.createElement("a");
            link.href = file.url;
            link.download = file.name;
            link.click();
        },

        // 预览文件
        previewSource(file) {
            const fileExtension = file.url?.slice(((file.url.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

            if (["jpg", "png"].includes(fileExtension)) {
                this.previewUrl = file.url;
            } else {
                const routeHref = this.$router.resolve({
                    path: "/training/preview",
                    query: {
                        src: file.url,
                    },
                }).href;

                window.open(routeHref, "__blank");
            }
        },

        // 是否可以预览。除了压缩包类型都可预览
        getIsPreview(fileName) {
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            const noPreviewExtensions = ["rar", "zip"];
            let isPreview = true;

            if (noPreviewExtensions.includes(fileExtension)) isPreview = false;

            return isPreview;
        },

        // 定义函数来计算字符的单位长度
        getUnitLength(char) {
            // 中文字符
            if (/[\u4e00-\u9fa5]/.test(char)) {
                return 2;
            }

            // 中文2单位标点
            if (/[，。！？、；：“”‘’（）【】《》——]/.test(char)) {
                return 2;
            }

            // 大写字母占2个单位
            if (/^[A-Z]$/.test(char)) {
                return 2;
            }

            // 英文小写字母和数字，占1个单位
            if (/^[a-z0-9]$/.test(char)) {
                return 1;
            }

            return 1; // 默认单位为 1
        },

        // 格式化文件名
        formatFileName(fileName, nameLength = 34) {
            // 提取文件扩展名
            const extIndex = fileName.lastIndexOf(".");
            const fileExt = fileName.slice(extIndex); // 包括点号的扩展名

            // 去掉扩展名部分，获取文件名
            const nameWithoutExt = fileName.slice(0, extIndex);

            // 计算文件名的单位长度
            let unitCount = 0;
            let i = 0;
            while (i < nameWithoutExt.length && unitCount <= nameLength) {
                unitCount += this.getUnitLength(nameWithoutExt[i]);
                i++;
            }

            // 如果单位长度没有超过38个单位，直接返回原文件名
            if (unitCount <= nameLength) {
                return fileName;
            }

            // 截取文件名的前一部分
            const filePart = {
                lastPart: "",
                lastPartCount: 0,
                firstPart: "",
                firstPartCount: 0,
            };

            for (let index = nameWithoutExt.length - 1; index >= 0; index--) {
                if (filePart.lastPartCount < 4) {
                    filePart.lastPart = nameWithoutExt[index] + filePart.lastPart;
                    filePart.lastPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            for (let index = 0; index < nameWithoutExt.length; index++) {
                if (filePart.firstPartCount < nameLength - filePart.lastPartCount - 4) {
                    filePart.firstPart += nameWithoutExt[index];
                    filePart.firstPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            // 格式化文件名
            return filePart.firstPart + "...." + filePart.lastPart + fileExt;
        },

        // 获取文件icon
        getFileIcon(fileName) {
            const iconList = {
                rar: require("../../assets/icons/zip-icon.svg"),
                zip: require("../../assets/icons/zip-icon.svg"),
                doc: require("../../assets/icons/doc-icon.svg"),
                docx: require("../../assets/icons/doc-icon.svg"),
                xls: require("../../assets/icons/xls-icon.svg"),
                xlsx: require("../../assets/icons/xls-icon.svg"),
                pdf: require("../../assets/icons/pdf-icon.svg"),
                jpg: require("../../assets/icons/img-icon.svg"),
                png: require("../../assets/icons/img-icon.svg"),
            };
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return iconList[fileExtension] || iconList["jpg"];
        },

        //查看详情
        clickViewDetail(row) {
            // this.viewDetail = true;
            // this.teacher_comment = row.teacher_comment;
            // this.ai_evaluate = row.ai_evaluate;
            // this.files = row.file;
            // this.student_submit_id = row.id;
            // if (this.role === 3) {
            //     this.submit_content = row.content;
            // } else {
            //     this.submit_content = row.content;
            // }

            const param = {
                sx_id: row.sx_id,
                s_id: row.s_id,
            };

            this.$shttp.axiosGetBy(this.$api.showStuDirllDetail, param, (res) => {
                if (res.code === 200) {
                    this.teacher_comment = res.data.teacher_comment;
                    this.ai_evaluate = res.data.ai_evaluate;
                    this.files = res.data.file;
                    this.student_submit_id = res.data.id;
                    this.submit_content = res.data.content;

                    this.viewDetail = true;
                } else {
                    this.$message.error("获取详情错误");
                }
            });
        },
        handleCurrentChange(val) {
            if (val) {
                this.currentRow = val;
                this.student_submit_id = val.id;
            }
        },
        //提交评语/分数
        submitContent() {
            let formData = new FormData();
            formData.append("id", this.student_submit_id);
            if (this.teacher_comment) {
                formData.append("teacher_comment", this.teacher_comment);
            }
            if (this.teacher_score) {
                formData.append("teacher_score", this.teacher_score);
            }
            this.$shttp.axiosPost(
                this.$api.drill_teaCommentStuDrill,
                formData,
                (res) => {
                    if (res.code === 200) {
                        this.viewDetail = false;
                        this.$message.success(res.msg);
                        this.getStudentPractical();
                        this.teacher_score = 0;
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },
        //分页
        practicalCurrentChange(val) {
            this.practicalPages.currentPageNum = val;
            this.getStudentPractical();
        },

        // 关闭文件预览
        closePreview() {
            this.previewUrl = "";
        },
         // 查看评价详情
         handleAssessmentDetail(row) {
                    if (row.status !== 1) {
                        this.$message.warning("学生暂未提交");
                        return;
                    }
                let role=localStorage.getItem("role")
            //  
                // // 如果是从上课中过来的 不管了 type==2
                // if(Number(localStorage.getItem("project_type")==2)){
                    this.$router.push({path:"/teacherClass/scoreBreakdown",query:{s_id:row.s_id,...this.$route.query}})
                // }
                // // this.$router.push({path:role==4?"/qualityCourse/project/scoreBreakdown":'/qualityCourse/scoreBreakdown',query:{s_id:row.s_id,...this.$route.query}})
                // if(Number(localStorage.getItem("project_type")==3)){
                //     this.$router.push({path:"/qualityCourse/project/scoreBreakdown",query:{s_id:row.s_id,...this.$route.query}})
                // }
                    // this.dialogData.p_id = row.id;
                    // this.dialogData.id = this.$route.query.id;
                    // this.dialogData.s_id = row.s_id;
                    // this.dialogData.visible = true;
        },
    },
};
</script>

<style scoped lang="scss">
ul,
li {
    margin: 0;
    padding: 0;
    list-style: none;
}
.training-submission {
    height: calc(100% - 90px);
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 10px 30px 30px 30px;
    .detail-title {
        cursor: pointer;
        &.detail-title:hover {
            color: #409eff;
        }
    }
    .detail-text {
        margin-bottom: 10px;
        ::v-deep img {
            max-width: 100%;
            max-height: 100%;
        }
    }
}
.pages-center {
    margin-bottom: 20px;
}

.teacher-comments {
    display: flex;
    flex-direction: column;
    // height: 200px;
    // padding: 0 20px;
    margin-top: 20px;
    .comments {
        margin-top: 10px;
        padding: 20px;
        background-color: #fcfcfc;
        border-radius: 4px;
    }
    .textarea {
        padding-top: 20px;
    }
}
.pw-input {
    width: 120px;
    margin-right: 5px;
}

::v-deep .el-dialog {
    position: absolute;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 90vh;
    overflow: hidden;

    .el-dialog__header {
        padding: 15px 20px;
    }

    .el-dialog__body {
        padding: 0;
    }
}

.comment-content {
    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .comment-txt {
        width: 100%;
        // padding: 0 20px;
        box-sizing: border-box;
    }
}

.detail-box {
    ::v-deep .el-scrollbar__wrap {
        width: calc(100% - 40px);
        max-height: calc(90vh - 55px - 66px - 40px);
        // padding: 20px 20px;
        box-sizing: border-box;
        margin: 10px 20px !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &_answer {
        .answer-file-list {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            .file-item {
                width: calc((100% - 20px) / 3);
                height: 72px;
                border-radius: 4px;
                background-color: #f6f6f6;
                box-sizing: border-box;
                padding: 16px;
                display: flex;
                gap: 10px;

                img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                }

                &_info {
                    width: calc(100% - 50px);

                    .info-top {
                        white-space: nowrap;
                    }

                    .info-bottom {
                        margin-top: 6px;
                        display: flex;
                        justify-content: space-between;
                        align-content: center;

                        &_size {
                            color: #999999;
                        }

                        .el-button {
                            padding-block: 0;
                        }
                    }
                }
            }
        }
    }
}

.preview-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.3);

    ::v-deep .el-image-viewer__wrapper {
        .el-image-viewer__mask {
            display: none;
        }

        .el-icon-circle-close {
            display: none;
        }

        .el-image-viewer__canvas img {
            width: 40% !important;
            height: auto !important;
        }
    }

    .el-icon-close {
        position: absolute;
        right: 50px;
        top: 30px;
        font-size: 40px;
        cursor: pointer;
        color: #ffffffda;
        z-index: 9999;
    }
}

.comment-btns {
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
